import { useState } from "react";

import styled from "styled-components/macro";

import FnrSortHandle from "UI/FnrSortHandle/FnrSortHandle";

const SDiv = styled("div")`
  display: flex;
  align-items: center;
`;

const ChildrenContainer = styled("div")`
  flex-grow: 1;
  margin-right: 4px;
`;

const ItemWithHandle = ({
  children,
  onPointerDown,
  hasHandle = true,
  ...rest
}) => {
  const [showHandle, setShowHandle] = useState(false);

  return (
    <SDiv
      onMouseOver={() => setShowHandle(true)}
      onMouseOut={() => setShowHandle(false)}
      {...rest}
    >
      <ChildrenContainer>{children}</ChildrenContainer>
      {hasHandle ? (
        <FnrSortHandle
          onPointerDown={onPointerDown}
          show={showHandle}
          onClick={(e) => {
            // If the containing element has a click event, we don't want it to fire.
            e.stopPropagation();
          }}
          data-cy="ItemWithHandle__SortHandle"
        />
      ) : null}
    </SDiv>
  );
};

export default ItemWithHandle;
